import { z } from 'zod';

import { UuidSchema } from '../../common/id/id';

/**
 * Attaching finalized evidence to a step.
 *
 * The member has already run the presigned upload (presign → PUT → finalize),
 * so this carries an **asset id**, never bytes and never a storage key: media
 * owns the object, verification owns the claim that it answers a step.
 *
 * There is no `kind` field. The route names the step and the step declares its
 * media kind (`evidenceKindForStep`), so a client-sent kind would be a second
 * opinion the server would have to either trust — letting a profile photo be
 * filed as an ID document — or ignore.
 */
export const SubmitStepSchema = z
  .object({
    mediaAssetId: UuidSchema,
  })
  .strict();

export type SubmitStepRequest = z.infer<typeof SubmitStepSchema>;
